import { formatUnits } from 'viem';

export const formatPrice = (price: bigint | number) => {
  let formatted;
  if (typeof price === 'bigint') {
    formatted = formatUnits(price, 18);
  } else {
    formatted = `${price}`;
  }
  const firstNonZeroAfterDecimal = (formatted.match(/\.0*[1-9]/)?.[0].length || 0) - 1;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits:
      formatted.indexOf('.') >= 0 ? (firstNonZeroAfterDecimal > 2 ? firstNonZeroAfterDecimal : 2) : 2,
  }).format(Number(formatted));
};
